// src/components/Logs/Logs.jsx
import React, { useState } from "react";
import LogsList from "./LogsList";
import LogsStats from "./LogsStats";
import LogDetailModal from "./LogDetailModal";
import "./Logs.css";

const Logs = () => {
  const [activeTab, setActiveTab] = useState("list");
  const [selectedLog, setSelectedLog] = useState(null);
  const [showDetailModal, setShowDetailModal] = useState(false);

  const handleViewDetails = (log) => {
    setSelectedLog(log);
    setShowDetailModal(true);
  };

  const handleCloseModal = () => {
    setShowDetailModal(false);
    setSelectedLog(null);
  };

  return (
    <div className="logs-container">
      {/* Header */}
      <div className="logs-header">
        <div>
          <h1 className="logs-title">Audit Logs</h1>
          <p className="logs-subtitle">
            System-wide audit trail for compliance and transparency
          </p>
        </div>
      </div>

      {/* Tabs */}
      <div className="logs-tabs">
        <button
          className={`logs-tab ${activeTab === "list" ? "logs-tab-active" : ""}`}
          onClick={() => setActiveTab("list")}
        >
          Logs List
        </button>
        <button
          className={`logs-tab ${activeTab === "stats" ? "logs-tab-active" : ""}`}
          onClick={() => setActiveTab("stats")}
        >
          Statistics
        </button>
      </div>

      {/* Tab Content */}
      <div className="logs-content">
        {activeTab === "list" && <LogsList onViewDetails={handleViewDetails} />}
        {activeTab === "stats" && <LogsStats />}
      </div>

      {/* Detail Modal */}
      {showDetailModal && (
        <LogDetailModal log={selectedLog} onClose={handleCloseModal} />
      )}
    </div>
  );
};

export default Logs;
